<template lang='pug'>
  i.svg-icon.svg-icon-camera
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d="M57.71,46.016c4.261,4.259,4.261,11.163,0,15.422c-4.258,4.26-11.163,4.26-15.422,0 c-4.258-4.259-4.258-11.163,0-15.422C46.547,41.757,53.452,41.757,57.71,46.016")
      path(d="M82.716,23.737h-7.534l-5.457-10.906H30.271l-5.451,10.911l-7.523,0.013 c-5.999,0.011-10.882,4.899-10.887,10.9L6.38,78.262c0,6.015,4.89,10.908,10.905,10.908h65.431c6.014,0,10.906-4.892,10.906-10.905 V34.643C93.622,28.627,88.729,23.737,82.716,23.737z M50,75.537c-12.027,0-21.812-9.783-21.812-21.811 c0-12.027,9.785-21.811,21.812-21.811S71.811,41.7,71.811,53.727C71.811,65.754,62.026,75.537,50,75.537L50,75.537z")

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '',
    },
  },

}
</script>